module.exports = __webpack_public_path__ + "static/7-2@2x-a7c9a04e7517aba13bb5dd6c7cfd6961.png";